<template>
  <div class="two-fa-modal">
    <div class="two-fa-modal__icon">
      <img src="../../../shared/assets/images/new_2fa.svg" alt="icon" />
    </div>

    <div class="two-fa-modal__header">{{ $t('2FAModal | title') }}</div>

    <div class="two-fa-modal__body">
      {{ $t('2FAModal | description') }}
    </div>

    <div class="footer">
      <base-button type="cta" size="lg" @onClick="redirectToTwoFaSettings">
        {{ $t('2FAModal | action') }}
      </base-button>
    </div>
  </div>
</template>

<script setup>
import BaseButton from '@/shared/ui/BaseButton/BaseButton.vue'
import { CONFIG } from '@/app/config/config'

function redirectToTwoFaSettings() {
  window.location = `${CONFIG.EMCD_URL}/profile/security`
}
</script>

<style scoped lang="scss">
.two-fa-modal {
  color: var(--text-1);
  line-height: 1.2;
  word-break: break-word;
}

.two-fa-modal__icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 36px;
  border-radius: 100%;
}

.two-fa-modal__header {
  margin-top: 50px;
  width: 100%;
  display: flex;
  justify-content: center;
  text-align: center;
  font-weight: 700;
  font-size: 1.725rem; // 28px
  line-height: 1;
}

.two-fa-modal__body {
  margin: 20px auto 40px auto;
  max-width: 370px;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 500;
  color: var(--text-2);
  text-align: center;
}

.footer {
  margin-bottom: 10px;
}
</style>
